import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const paste = (props) => (
  <SvgIcon width="13.092" height="16" viewBox="0 0 13.092 16" {...props}>
    <path
      d="M14.636,1.455H11.6a2.173,2.173,0,0,0-4.1,0H4.455A1.459,1.459,0,0,0,3,2.909V14.545A1.459,1.459,0,0,0,4.455,16H14.636a1.459,1.459,0,0,0,1.455-1.455V2.909A1.459,1.459,0,0,0,14.636,1.455Zm-5.091,0a.727.727,0,1,1-.727.727A.729.729,0,0,1,9.545,1.455Zm5.091,13.091H4.455V2.909H5.909V5.091h7.273V2.909h1.455Z"
      transform="translate(-3)"
    />
  </SvgIcon>
);
export default paste;



// WEBPACK FOOTER //
// ./src/common/icons/Paste/index.tsx